import React from 'react';

// Internal Import
import { success, warning, error } from '../theme/colors';

// External Import
import { common } from "@mui/material/colors";
import { Stack, Dialog,Typography } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';

export interface DialogStatusProps { 
    open: boolean,
    screen: string,
    message: string,
    handleClose?: ()=>void
    status: 'success'|'warning'|'error'
}
export const DialogStatusComponent: React.FC<DialogStatusProps> = ({open, status, screen, message, handleClose}) => {
    
    if (open) {
        
        const componentBodyAndTitle = (isBody: boolean) => {
            if (status == 'success') {
                if (!isBody) { return success.main }
                return <CheckCircleOutlineRoundedIcon sx={{ width: 32, height: 32, color: '#fff' }} />;
            } else if (status == 'warning') {
                if (!isBody) { return warning.main }
                return <WarningAmberRoundedIcon sx={{ width: 32, height: 32, color: '#fff' }} />;
            } else {
                if (!isBody) { return error.main }
                return <ErrorOutlineRoundedIcon sx={{ width: 32, height: 32, color: '#fff' }} />;
            }
        }

        return (
            <Dialog 
                open={open} 
                onClose={handleClose} 
                sx={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
            >
                <Stack direction={'column'} sx={{ width: {xs: 200, sm: 300, md: 400} }}>
                    <Stack
                        py={'1em'}
                        width={'100%'}
                        display={'flex'}
                        direction={'column'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        sx={{ backgroundColor: `${componentBodyAndTitle(false)}` }}
                    >
                        {componentBodyAndTitle(true)}
                        
                        <Typography
                            variant="body2"
                            color={common.white}
                            sx={{
                                textAlign: 'center',
                                fontFamily: 'Montserrat',
                                textTransform: 'capitalize'
                            }}
                        >
                            {screen + " " + status}
                        </Typography>
                    </Stack>
                    <Typography
                        variant="body2"
                        color={common.black}
                        sx={{
                            py: '2em',
                            fontWeight: '500',
                            textAlign: 'center',
                            fontFamily: 'Montserrat',
                        }}
                    >
                        {message}
                    </Typography>
                </Stack>
            </Dialog>
        )
    } 
    return null;
};
